import styled from 'styled-components';

export const FooterContainer = styled.div`
  background-color: var(--color-gris);
  color: var(--color-coral);
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-around;
  padding: 35px 10vw 20px;
`;

export const LogoFooterContainer = styled.div`
  justify-content: center;
  display: flex;
`;

export const LogoFooter = styled.img`
  width: 80%;
`;

export const FooterDataList = styled.ul`
  display: flex;
  flex-direction: column;
`;